module.exports = __webpack_public_path__ + "static/section-six-1a280d6f3cfe55b5d13a7a9366fba540.png";